
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 72 72","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.493 13.211v54.577l15.121-11.34h42.893a9 9 0 009-9V13.21a9 9 0 00-9-9H11.493a9 9 0 00-9 9z","stroke":"#fff","stroke-width":"3"}}),_c('path',{attrs:{"d":"M19.425 23.089h24.007M19.425 35.115h32.148","stroke":"currentColor","stroke-width":"3","stroke-linecap":"round"}})])
          )
        }
      }
    